import {  Table } from '@mui/material'
import { TableRow } from '@mui/material'
import { TableBody } from '@mui/material'
import { Paper } from '@mui/material'
import { TableCell } from '@mui/material'
import { TableHead } from '@mui/material'
import { TableContainer } from '@mui/material'
import  { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { AudioFileClient } from '../../api/server'
import { ExtendedClient } from '../../api/ExtendedClient'

const GlobalAudioFiles = () => {
  const [audioFiles, setAudioFiles] = useState([]);

  const globalInfo = useSelector((state) => state.globalInfo)


  function reload() {
    const client = (new ExtendedClient(AudioFileClient)).getClient();

    client.getGlobalAudioFiles().then(
      (data) => {
        setAudioFiles(data);
      }
    )
  }

  useEffect(() => {
    reload();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalInfo.currentCompanyId])

  function getUrl(path){
    if(path.startsWith("https"))
    { 
      return path
    }
    return process.env.REACT_APP_API_URL + "/" +  path;
  }

  return (
    <div>
       
       <h1>Marketing Audio Files</h1>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              {/* <TableCell>Size</TableCell> */}
              <TableCell>Preview</TableCell>
              <TableCell>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {audioFiles.map((row, index) => (
              <TableRow
                key={index}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                 
                <TableCell component="th" scope="row">
                  {row.name} 
                </TableCell>
                {/* <TableCell component="th" scope="row">
                  {formatBytes(row.fileSize)}
                </TableCell> */}
                
                <TableCell style={{ padding: 0 }}>
                  <figure style={{ margin: 0 }}>
                    <audio
                      controls
                      src={getUrl(row.path)}>
                      <a href={getUrl(row.path)}>
                        Download audio
                      </a>
                    </audio>
                  </figure>

                </TableCell>
               
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}

export default GlobalAudioFiles